import moment from 'moment';
import _get from 'lodash/get';
import {
    getHistoryChartType,
    getHistoryEventType
} from 'services/SensorHelper';
import { ConfigHelper, DataConverter } from 'services/charting';
import ConfigPresets from 'services/charting/presets';
import { PROXIMITY_STATES } from 'services/charting/data-converter';
import { AbstractChartController } from '../chart-abstract-base';

/* eslint class-methods-use-this: 0 */

/* @ngInject */
export default class ChartWaterDetectorController extends AbstractChartController {
    constructor(SensorEventsLoader, ToastService, $scope,EventEmitter) {
        super({
            SensorEventsLoader,
            ToastService,
            $rootScope: $scope.$root,
            EventEmitter,
        });
    }

    getEventTypes() {
        return [this.eventType, 'networkStatus'];
    }

    // Overrides AbstractChartController
    dataToLoad(days) { // eslint-disable-line no-unused-vars
        // We do not have a good way to aggregate water detector events for now, so we always load events
        return "events";
    }

    getConfigPreset() {
        return ConfigPresets.WaterDetector;
    }

    convertToSeries(data, spacerStart, spacerEnd, spacerMin, spacerMax) {
        return ConfigHelper.proximitySeries(
            data,
            spacerStart,
            spacerEnd,
            spacerMin,
            spacerMax
        );
    }

    convertEvents(events) {
        const {
            state,
            networkStatus
        } = DataConverter.splitByStateAndNetworkStatus(events);
        this.sanitizeStateEvents(state);
        const networkEventsTimestamps = DataConverter.getTimestampsFromNetworkStatusEvents(networkStatus)
        this.plotBands = DataConverter.createOfflineBands(
            networkEventsTimestamps,
            this.chartMin,
            this.chartMax
        );
        this.chartData = DataConverter.syncOfflineProximity(
            DataConverter.waterDetector(state, this.chartMin, this.chartMax),
            this.plotBands
        );
        return {
            data: this.chartData,
            plotBands: this.plotBands
        };
    }

    sanitizeStateEvents(stateEvents) {
        if (!stateEvents.length) {
            const state = _get(
                this.thing,
                'reported.waterPresent.state',
                null
            );
            if (state) {
                const updateTime = moment(
                    _get(this.thing, 'reported.waterPresent.updateTime')
                );
                stateEvents.push({
                    data: {
                        waterPresent: {
                            state,
                            updateTime:
                                updateTime < this.chartMin
                                    ? this.chartMin
                                    : updateTime
                        }
                    }
                });
            }
        }
    }

    addNetworkEventPoint() {
        const lastRangeIndex = this.chartData.length - 1;

        const lastRange = this.chartData[lastRangeIndex];
        const lastBand = this.plotBands[this.plotBands.length - 1];

        if (lastBand && lastRange && lastBand.to > lastRange.x2) {
            return;
        }

        const range = {
            x: lastRange.x,
            x2: this.chartMax,
            y: lastRange.y
        };

        this.chartData[lastRangeIndex] = range;
        const pointToUpdate = this.dataSeries.points.find(
            point => point.x === range.x
        );
        if (pointToUpdate) {
            pointToUpdate.update(range);
        }
    }

    onStateEventReceived(eventData) {
        const timestamp = moment(eventData.updateTime).valueOf();
        const state = PROXIMITY_STATES[eventData.state];

        const fakeFutureTimestamp = timestamp + 50; // just to make it visible

        const lastRangeIndex = this.chartData.length - 1;
        const lastBandIndex = this.plotBands.length - 1;

        const lastRange = this.chartData[lastRangeIndex];
        const lastBand = this.plotBands[lastBandIndex];

        const wasOffline = lastBand && lastBand.to > lastRange.x2;
        const stateChanged = lastRange.y !== state;

        let range;

        if (wasOffline) {
            range = {
                x: timestamp,
                x2: fakeFutureTimestamp,
                y: state
            };
            this.chartData.push(range);
            this.dataSeries.addPoint(range);
        } else if (!stateChanged) {
            range = {
                x: lastRange.x,
                x2: timestamp,
                y: state
            };
            this.chartData[lastRangeIndex] = range;
            const pointToUpdate = this.dataSeries.points.find(
                point => point.x === range.x
            );
            if (pointToUpdate) {
                pointToUpdate.update(range);
            }
        } else {
            range = {
                x: lastRange.x,
                x2: timestamp,
                y: lastRange.y
            };
            this.chartData[lastRangeIndex] = range;
            const pointToUpdate = this.dataSeries.points.find(
                point => point.x === range.x
            );
            if (pointToUpdate) {
                pointToUpdate.update(range, false);
            }

            range = {
                x: timestamp,
                x2: fakeFutureTimestamp,
                y: state
            };
            this.chartData.push(range);
            this.dataSeries.addPoint(range);
        }
    }

    $onInit() {
        this.chartType = getHistoryChartType(this.thing);
        this.eventType = getHistoryEventType(this.thing);

        super.$onInit();
    }
}
